import React from 'react'

import cn from 'classnames'
import { Box, BoxProps } from '@chakra-ui/react'

interface ICardProps {
  children?: React.ReactNode
  className?: string
}

const Card: React.FC<ICardProps & BoxProps> = ({
  children,
  className,
  ...rest
}: ICardProps & BoxProps) => {
  return (
    <Box className={cn('rounded-[2.5rem] bg-[#F5F5F5]', className)} {...rest}>
      {children}
    </Box>
  )
}

export default Card
